/**
 * Entrar ou cadastrar com a conta do Google.
 *
 * É uma navegação de verdade, não fetch: o servidor manda para o Google e o
 * retorno cai em /entrar/verificar com um token. Por isso um link e não um
 * botão com onClick -- assim funciona com o meio do botão, abre em outra aba
 * se a pessoa quiser, e o navegador mostra para onde vai.
 */
import { API_BASE_URL } from '../../app/runtime';

/**
 * Só aparece se o servidor tiver o Google configurado. Sem isto, o botão
 * levaria a uma tela de erro do Google -- pior que não existir.
 */
export function googleEnabled(): boolean {
  return Boolean(import.meta.env.VITE_GOOGLE_ENABLED);
}

export function GoogleButton({ label }: { label: string }) {
  return (
    <a className="btn btn--outline en-google" href={`${API_BASE_URL}/api/v1/auth/google/redirect`}>
      <GoogleMark />
      {label}
    </a>
  );
}

/** A marca do Google tem cores fixas: não acompanha o tema, por regra deles. */
function GoogleMark() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true" focusable="false">
      <path
        fill="#4285F4"
        d="M17.64 9.2c0-.64-.06-1.25-.16-1.84H9v3.48h4.84a4.14 4.14 0 0 1-1.8 2.72v2.26h2.91c1.7-1.57 2.69-3.88 2.69-6.62z"
      />
      <path
        fill="#34A853"
        d="M9 18c2.43 0 4.47-.8 5.96-2.18l-2.91-2.26c-.81.54-1.84.86-3.05.86-2.34 0-4.33-1.58-5.04-3.71H.96v2.33A9 9 0 0 0 9 18z"
      />
      <path fill="#FBBC05" d="M3.96 10.71a5.41 5.41 0 0 1 0-3.42V4.96H.96a9 9 0 0 0 0 8.08l3-2.33z" />
      <path
        fill="#EA4335"
        d="M9 3.58c1.32 0 2.5.45 3.44 1.35l2.58-2.58C13.46.89 11.43 0 9 0A9 9 0 0 0 .96 4.96l3 2.33C4.67 5.16 6.66 3.58 9 3.58z"
      />
    </svg>
  );
}
